<script>
import axios from "axios";
import {toast} from "vue3-toastify";
import modalKkMixin from "../conversation-club/modal-kk-mixin.js";
import vSelect from "vue-select";
import _ from "lodash";



export default {
  components: {vSelect},
  mixins: [modalKkMixin],
  props: ['lesson', 'current_semester', 'semesters'],
  name: "lesson-form",
  data() {
    return {
      selected_student:{},
      lesson_students:[],
      options:[],
      showM: false,
      lectors: [],
      products: [],
      lesson_expand: false,
      semestr_id: null,
    }
  },
  watch:{
    lesson:{
      handler: function (val) {

        this.loadLessonStudents()
      },
      deep: true
    },
    current_semester:{
      handler: function (val) {
        if (val){
          this.semestr_id = val.id
        }
      },
      immediate: true
    }
  },
  methods: {
    loadLessonStudents() {
      axios.get(`/onlajnovka/lessons/${this.lesson.id}/students`).then(response => {
        this.lesson_students = response.data.items
      })
    },

    onSearch(search, loading) {
      if(search.length) {
        loading(true);
        this.search(loading, search, this);
      }
    },

    search: _.debounce((loading, search, vm) => {
      fetch(
          `/onlajnovka/students/search?q=${escape(search)}`
      ).then(res => {
        res.json().then(json => (vm.options = json.items));
        loading(false);
      });
    }, 350),


    async loadLectors() {
      const r2 = await axios.get('/conversation-clubs/lectors.json', {
        params: {
          //level: this.lesson.level
          per: 100
        }
      })
      this.lectors = r2.data.items

      const p = await axios.get('/onlajnovka/products.json')
      this.products = p.data.items

    },

    handleProductChange() {
      // ziskatp roduct name
      const product = this.products.find(p => p.id == this.lesson.product_id)
      const name = product.name
      if (name.includes('ČTVRTEK')) {
        this.lesson.day = 4
      } else if (name.includes('ÚTERÝ')) {
        this.lesson.day = 2
      } else if (name.includes('STŘEDA')) {
        this.lesson.day = 3
      } else if (name.includes('PONDĚLÍ')) {
        this.lesson.day = 1
      } else if (name.includes('PÁTEK')) {
        this.lesson.day = 5
      }

      if (name.includes('20:00')) {
        this.lesson.hour = 20
      } else if (name.includes('19:00')) {
        this.lesson.hour = 19
      } else if (name.includes('18:00')) {
        this.lesson.hour = 18
      } else if (name.includes('17:00')) {
        this.lesson.hour = 17
      }

    },
    handleCancel(){
      this.$emit('close')
      this.hideModal()
    },
    removeStudent(s){
      console.log('remove student', s)
      if (confirm(`Opravdu smazat ${s.first_name ? s.first_name:''}, ${s.nickname ? s.nickname : s.email} ? (student se odebere ihned, i bez potvrzování změn lekce)`)) {

        axios.delete(`/onlajnovka/lessons/${this.lesson.id}/student/${s.id}`).then(response => {
          toast('Student odebrán', {type: 'success'});
          this.loadLessonStudents()

          this.$emit('calendarUpdated')
        })

      }

    },
    addStudent(){
      console.log('add student', this.selected_student)
      if (this.selected_student.id){
        axios.post(`/onlajnovka/lessons/${this.lesson.id}/students`, {student_id: this.selected_student.id}).then(response => {
          this.loadLessonStudents()
        }).catch(error => {
          console.error(error)
          toast('Chyba: '+ error.response.data.errors.join('<br>'), {type: 'error', dangerouslyHTMLString: true});
        })
        this.selected_student = {}
      }else {
        toast('Vyberte studenta', {type: 'error'});
      }
    },


    handleSaveChanges() {

      if (!this.lesson.product_id) {

        toast('Vyberte produkt', {type: 'error'});
        return
      }
      if (!this.lesson.lector_id) {
        toast('Vyberte lektora', {type: 'error'});
        return
      }
      if (!this.lesson.day) {
        toast('Vyberte den', {type: 'error'});
        return
      }
      if (!this.lesson.hour) {
        toast('Vyberte čas', {type: 'error'});
        return
      }
      if (this.lesson.id>0){
        //update

        this.lesson.semester_id = this.semestr_id

        axios.put(`/onlajnovka/lessons/${this.lesson.id}`, {lesson: this.lesson}).then(response => {
          this.$emit('saved', response.data)

        }).catch(error => {
          console.error(error)
        })

      }else {


        axios.post('/onlajnovka/lessons', {lesson: this.lesson}).then(response => {
          this.$emit('saved', response.data)
        }).catch(error => {
          console.error(error)
        })
      }

      this.$emit('save', this.lesson)
      this.hideModal()
    },
  },
  mounted() {
    this.loadLectors()

  }

}
</script>

<template>
  <vue-final-modal v-model="showM" classes="modal-container " content-class="modal-content-f mcw1">

    <div class="modal-header">
      <span class="modal__title">Detail lekce

      </span>
      <button type="button" class="close" @click.prevent="hideModal" aria-label="Close">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>


    <div class="modal__content">

      <div class="row">

        <div class="col-md-6">
          <div class="form-group">
            Produkt
            <select class="form-control" @change="handleProductChange" v-model="lesson.product_id">
              <option></option>
              <option v-for="p in products" :value="p.id">{{ p.id }} - {{ p.name }}</option>
            </select>

          </div>
        </div>

        <div class="col-md-6">
          <div class="form-group">
           Semestr
            <select class="form-control" @change="" v-model="semestr_id">
              <option></option>
              <option v-for="p in semesters" :value="p.id">{{ p.name }}</option>
            </select>

          </div>
        </div>



        <div class="col-md-6">
                  <div class="form-group">

                    <label>Úroveň</label>
                    <input type="text" v-model="lesson.level_name" class="form-control "  />
                  </div>
        </div>

        <div class="col-md-6">
          <div class="form-group">
            <label>Lektor</label>
            <select class="form-control" v-model="lesson.lector_id">
              <option></option>
              <option v-for="t in lectors" :value="t.id">{{ t.first_name }} {{ t.last_name }}</option>
            </select>
          </div>
        </div>

        <div class="col-md-2">
          <div class="form-group">
            <label>Čas</label>
            <select class="form-control" v-model="lesson.hour">
              <option></option>
              <option v-for="i in [17,18,19,20]" :value="i">{{ i }}:00</option>
            </select>
          </div>
        </div>


        <div class="col-md-2">
          <div class="form-group">
            <label>Den</label>
            <select class="form-control" v-model="lesson.day">
              <option></option>
              <option v-for="(d, idx) in ['Pondělí', 'Úterý', 'Středa', 'Čtvrtek', 'Pátek']" :value="idx+1">
                {{ d }}
              </option>
            </select></div>
        </div>

        <div class="col-md-6">
          <div class="form-group">
            <label>Kapacita</label>
            <input type="number" v-model="lesson.capacity" class="form-control w-auto"  />
          </div>

        </div>
      </div>


      <div class="d-flex" v-if="lesson.id>0">
        <div style="min-width: 70%">
          <v-select v-model="selected_student" @search="onSearch" :filterable="false" :options="options" >

            <template #option="option">
              <div class="d-center row">
                <div class="col-1">
                  <img :src="option.profile_image_url" v-if="option.profile_image_url" class="icoproduct">

                </div>
                <div class="col-5">{{ option.email }}</div>
                <div class="col-6">{{ option.name }} {{ option.surname }}</div>
              </div>
            </template>
            <template #selected-option="option">
              <div class="selected d-center">
                <img :src="option.profile_image_url" v-if="option.profile_image_url" class="icoproduct"> {{ option.email }}
              </div>
            </template>
          </v-select>
        </div>
        <button class="btn btn-outline-dark btn-sm ml-2" @click.prevent="addStudent"  >Přidat studenta</button>
      </div>


      <table class="table table-sm mt-2">
        <tr v-for="s in lesson_students">
          <td>{{s.name}} {{s.surname}}</td>
          <td>{{s.email}}</td>
          <td><a href="#" @click.prevent="removeStudent(s)"><span class="material-symbols-outlined">delete</span></a></td>
        </tr>
      </table>


      <div class="actions-inb">

      <button class="btn btn-primary" @click="handleSaveChanges">Uložit změny</button>
      <button class="btn btn-outline-dark ml-4" @click="handleCancel">zrušit</button>

      </div>
    </div>




  </vue-final-modal>
</template>

<style >
.modal-content-f {

}
</style>